<template>
  <div id="meetingMemberInOrder" class="safe-distance-top-header">
    <Header pageTitle="报名信息" />
    <div class="box">
      <!-- 配置对象 -->

      <van-cell-group>
        <div
          v-for="(signUpItem, key) in signUpSettings"
          :key="signUpItem.code + key"
        >
          <div
            v-if="signUpItem.code == 'headPhoto' && memberData[signUpItem.code]"
          >
            <div
              class="van-cell"
              style="
                width: 100%;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span>头像</span>
              <img
                style="width: 45px; height: 45px; border-radius: 50%"
                :src="$global.imgUrl + memberData[signUpItem.code]"
                alt=""
              />
            </div>
          </div>
          <!-- 职称和学科领域 -->
          <div
            v-if="signUpItem.code == 'titleList' && memberData[signUpItem.code]"
          >
            <van-cell
              v-for="(title, k) in memberData[signUpItem.code]"
              :key="'title' + k"
              :title="k == 0 ? '职称' : ''"
              :value="
                title.levelOneName +
                `${title.levelTwo ? ' - ' + title.levelTwo : ''}`
              "
            ></van-cell>
          </div>
          <div
            v-if="
              signUpItem.code == 'subjectList' && memberData[signUpItem.code]
            "
          >
            <van-cell
              v-for="(subject, j) in memberData[signUpItem.code]"
              :key="'subject' + j"
              :title="j == 0 ? '学科领域' : ''"
              :value="subject.levelOneName + ' - ' + subject.levelTwoName"
            ></van-cell>
          </div>
          <div v-if="signUpItem.code == 'org' && memberData[signUpItem.code]">
            <van-cell
              :title="signUpItem.value"
              :value="memberData[signUpItem.code].name"
            />
          </div>
          <div
            v-if="
              signUpItem.code == 'multipleChoice' && memberData[signUpItem.code]
            "
          >
            <div class="van-cell">
              <span class="van-cell__title">{{ signUpItem.value }}</span>
              <div class="van-cell__value">
                <div v-for="item in memberData[signUpItem.code]" :key="item">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              signUpItem.code == 'singleChoice' && memberData[signUpItem.code]
            "
          >
            <div class="van-cell">
              <span class="van-cell__title">{{ signUpItem.value }}</span>
              <div class="van-cell__value">
                {{ memberData[signUpItem.code] }}
              </div>
            </div>
          </div>
          <div
            v-if="signUpItem.code == 'imageList' && memberData[signUpItem.code]"
          >
            <div
              class="van-cell"
              style="display: flex; justify-content: space-between"
            >
              <span class="van-cell__title">{{ signUpItem.value }}</span>
              <div class="van-cell__value">
                <img
                  v-for="item in memberData[signUpItem.code]"
                  :key="item.url"
                  :src="$global.imgUrl + item.url"
                  style="margin-left: 5px"
                  width="100"
                  height="100"
                />
              </div>
            </div>
          </div>
          <div v-if="signUpItem.code == 'file' && memberData[signUpItem.code]">
            <div
              class="van-cell"
              style="display: flex; justify-content: space-between"
            >
              <span class="van-cell__title">{{ signUpItem.value }}</span>
              <div class="van-cell__value">
                <div
                  v-for="item in memberData[signUpItem.code]"
                  :key="item.name"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <van-cell
            v-if="
              signUpItem.code != 'headPhoto' &&
              signUpItem.code != 'titleList' &&
              signUpItem.code != 'subjectList' &&
              signUpItem.code != 'multipleChoice' &&
              signUpItem.code != 'singleChoice' &&
              signUpItem.code != 'imageList' &&
              signUpItem.code != 'file' &&
              signUpItem.code != 'org' &&
              memberData[signUpItem.code]
            "
            :title="signUpItem.value"
            :value="memberData[signUpItem.code]"
          />
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
  name: "meetingMemberInOrder",
  components: {
    Header,
  },
  data() {
    return {
      memberData: {},
      signUpSettings: [],
    };
  },
  created() {
    if (this.$route.query.id) {
      // 查询会议报名表单项数据
      this.signUpsConfig();
    } else {
      this.$toast("请重新选择参会人");
      this.$router.go(-1);
    }
  },
  methods: {
    async signUpsConfig() {
      const _this = this;
      var resp = await _this.$apis.goodsServe.meetingFormTem(
        _this.$route.query.goodsId
      );
      if (resp.resultCode == 200) {
        resp.data.forEach((item, index) => {
          switch (item.code) {
            case "birthday":
              // 接口返回配置项为 birthday 出生年份，修改为birthdayYear对应参会人信息中字段，只显示年
              item.code = "birthdayYear";
              break;
            case "titles":
              item.code = "titleList";
              break;
            case "subjects":
              // 对应会议参会人数据中字段
              item.code = "subjectList";
              break;
          }
          _this.$set(_this.signUpSettings, index, item);
          _this.$set(_this.memberData, item.code, "");
        });
        // 查询报名人信息
        this.memberInfo();
      } else {
        _this.$toast(resp.resultDesc);
      }
    },
    async memberInfo() {
      const _this = this;
      var resp2 = await _this.$apis.myServe.meetingMemberInfoInOrders({
        id: _this.$route.query.id,
      });
      if (resp2.resultCode == 200) {
        let signUserInfo = resp2.data[0];
        for (const key in _this.memberData) {
          if (
            key === "text" ||
            key === "dropDown" ||
            key === "multipleChoice" ||
            key === "singleChoice" ||
            key === "date" ||
            key === "file" ||
            key === "imageList"
          ) {
            let customize = JSON.parse(signUserInfo.customizeConfig).filter(
              (item) => item.code === key
            );
            console.log(customize, "customize");
            if (customize.length) {
              _this.memberData[key] = customize[0].value || "";
            } else {
              _this.memberData[key] = "";
            }
          } else if (key === "org") {
            _this.memberData[key] = JSON.parse(signUserInfo[key]);
          } else {
            _this.memberData[key] = signUserInfo[key];
          }
        }
      } else {
        _this.$toast(resp2.resultDesc);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#meetingMemberInOrder {
  background-color: #f5f5f5;
  padding: 12px;
  .box {
    border-radius: 8px;
    overflow: hidden;
  }
}
::v-deep.van-cell__title {
  flex-grow: 1;
  flex-shrink: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

::v-deep.van-cell__value {
  flex-grow: 2;
  flex-shrink: 0;
}

::v-deep.van-cell::after {
  border: 0;
}
</style>
